<div
  class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in"
  (click)="onBackdropClick()"
>
  <div
    class="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-scale-in"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-center justify-between p-6 border-b border-gray-100">
      <h2 class="text-xl font-bold text-gray-900">How will you use JustTeach?</h2>
      <button
        (click)="close()"
        class="p-2 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
      >
        <lucide-icon [img]="icons.X" class="w-5 h-5 text-gray-500"></lucide-icon>
      </button>
    </div>

    <!-- Options -->
    <div class="p-6 space-y-4">
      <!-- Teacher Option -->
      <button
        (click)="selectTeacher()"
        class="w-full p-6 bg-gray-50 hover:bg-orange-50 border-2 border-gray-200 hover:border-brand rounded-xl text-left transition-all cursor-pointer group"
      >
        <div class="flex items-start gap-4">
          <div class="bg-brand/10 group-hover:bg-brand/20 p-3 rounded-xl transition-colors">
            <lucide-icon [img]="icons.GraduationCap" class="w-8 h-8 text-brand"></lucide-icon>
          </div>
          <div>
            <h3 class="text-lg font-bold text-gray-900 mb-1">I'm a Teacher</h3>
            <p class="text-sm text-gray-500">Create lesson plans, assignments, and grade student work</p>
          </div>
        </div>
      </button>

      <!-- Student Option -->
      <button
        (click)="selectStudent()"
        class="w-full p-6 bg-gray-50 hover:bg-blue-50 border-2 border-gray-200 hover:border-blue-500 rounded-xl text-left transition-all cursor-pointer group"
      >
        <div class="flex items-start gap-4">
          <div class="bg-blue-100 group-hover:bg-blue-200 p-3 rounded-xl transition-colors">
            <lucide-icon [img]="icons.BookOpen" class="w-8 h-8 text-blue-600"></lucide-icon>
          </div>
          <div>
            <h3 class="text-lg font-bold text-gray-900 mb-1">I'm a Student</h3>
            <p class="text-sm text-gray-500">Complete assignments shared by your teacher</p>
          </div>
        </div>
      </button>
    </div>
  </div>
</div>
